import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  TextField,
  FormControl,
  Paper,
  Typography,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(2, 4),
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    backgroundColor: "#f9f9f9",
    boxShadow:
      "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    color: "#04286F",
    fontWeight: 500,
  },
  formControl: {
    marginBottom: theme.spacing(1),
    width: "100%",
  },
}));

const RemarkField = ({ formData, handleChange, disable }) => {
  const classes = useStyles();
  const [remarkError, setRemarkError] = useState("");

  const disallowedRemarkPattern = /[@#!?<>$%^*{}|~`=]/;

  const handleRemarkChange = (e) => {
    const newValue = e.target.value;

    if (disallowedRemarkPattern.test(newValue)) {
      setRemarkError(
        "Special characters like @, #, !, ?, <, >, $, %, ^, *, {, }, |, ~, `, and = are not allowed"
      );
    } else {
      setRemarkError("");
      const cleanValue = newValue.replace(/\s+/g, " ")
      handleChange({
        target: {
          name: "remark",
          value: cleanValue,
        },
      });
    }
  };

  return (
    <Paper className={classes.paper} elevation={2}>
      <Typography variant="h6" className={classes.sectionTitle}>
        Remark
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl className={classes.formControl}>
            <TextField
              id="remark"
              name="remark"
              label="Remark"
              variant="outlined"
              value={formData.remark || ""}
              onChange={handleRemarkChange}
              fullWidth
              multiline
              rows={4}
              disabled={disable}
              error={!!remarkError}
              helperText={remarkError}
            />
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  );
};

RemarkField.propTypes = {
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  disable: PropTypes.bool,
};

export default RemarkField;
